// La barra de acciones inferior (`position: fixed; bottom: 0`) queda anclada al
// viewport de LAYOUT, no al visible. Cuando se abre el teclado del teléfono, el
// visible se encoge pero el de layout no, así que la barra —y con ella el botón
// "Guardar conteo"— queda tapada por el teclado. Pasa de verdad: reportado desde
// un Android con el navegador embebido de Telegram, contando inventario.
//
// Primera línea de defensa: `interactive-widget=resizes-content` en el meta
// viewport (ver layouts/mobile.html.erb), que hace que el navegador encoja el
// layout. Esto es el respaldo para donde eso no se respete: se mide cuánto tapa
// el teclado con la API VisualViewport y se sube la barra esa distancia.
//
// Las dos vías componen sin pelearse: si el navegador ya encogió el layout, el
// solapamiento medido es ~0 y no se desplaza nada.
export function initKeyboardAwareBottomBar() {
  const bar = document.querySelector(".m-bottom-bar")
  const toasts = document.getElementById("m-toasts")
  const vv = window.visualViewport
  if (!bar || !vv) return

  let pending = false

  function apply() {
    pending = false
    // Alto del layout que el viewport visible NO cubre por abajo: el teclado.
    const overlap = Math.max(0, window.innerHeight - (vv.height + vv.offsetTop))
    const shift = overlap > 0 ? `translateY(-${overlap}px)` : ""
    bar.style.transform = shift
    if (toasts) toasts.style.transform = shift
  }

  function schedule() {
    if (pending) return
    pending = true
    window.requestAnimationFrame(apply)
  }

  vv.addEventListener("resize", schedule)
  vv.addEventListener("scroll", schedule)
  apply()
}

// Al enfocar un campo, asegura que quede visible por encima del teclado. El
// navegador lo hace solo casi siempre, pero con la barra fija de por medio a
// veces el input queda justo detrás de ella.
export function keepFocusedFieldVisible() {
  document.addEventListener(
    "focusin",
    (event) => {
      const field = event.target
      if (!field.matches || !field.matches("input, select, textarea")) return
      // Se espera a que el teclado termine de abrir y el viewport de acomodarse.
      setTimeout(() => {
        field.scrollIntoView({ block: "center", behavior: "smooth" })
      }, 250)
    },
    true
  )
}
